import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Safety", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Metric", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates the need for additional design solutions to provide a safe cross section for all modes. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Scoring description", -1)
const _hoisted_6 = { class: "flex items-start gap-4" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dd", null, "Two to three lanes", -1)
const _hoisted_9 = { class: "flex items-start gap-4" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dd", null, "Five lanes", -1)
const _hoisted_12 = { class: "flex items-start gap-4" }
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dd", null, "Four lanes", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Pedestrian", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Mobility", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates the presence or absence of curb zone buffers from adjacent traffic. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_20 = { class: "flex items-start gap-4" }
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dd", null, "Parking or bike lane", -1)
const _hoisted_23 = { class: "flex items-start gap-4" }
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("dd", null, "Travel lane", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "Access", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates the ease of providing closely spaced marked pedestrian crossings. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_30 = { class: "flex items-start gap-4" }
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("dd", null, "Two to three lanes", -1)
const _hoisted_33 = { class: "flex items-start gap-4" }
const _hoisted_34 = { class: "mt-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("dd", null, "Five lanes", -1)
const _hoisted_36 = { class: "flex items-start gap-4" }
const _hoisted_37 = { class: "mt-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("dd", null, "Four lanes", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Greening", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", null, "Metric", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates potential space for stormwater swales or trees between the curbs (i.e., in the roadway). This may be relevant if there is not space in the sidewalk, where greening functions are typically provided. ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h3", null, "Scoring description", -1)
const _hoisted_43 = { class: "flex items-start gap-4" }
const _hoisted_44 = { class: "mt-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("dd", null, "Presence of curb zone (e.g., parking lane) or median", -1)
const _hoisted_46 = { class: "flex items-start gap-4" }
const _hoisted_47 = { class: "mt-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("dd", null, "No curb zone or median", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Bicycle", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h3", null, "Mobility", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates if the bicycle facility is appropriate for the speed and volume of roadway. PBOT has designated protected bike lanes as the preferred design on roadways where separation is called for. ", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_54 = { class: "flex items-start gap-4" }
const _hoisted_55 = { class: "mt-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("dd", null, "Seven or more foot wide buffered or protected bike lane", -1)
const _hoisted_57 = { class: "flex items-start gap-4" }
const _hoisted_58 = { class: "mt-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("dd", null, "Less than seven foot wide bike lane", -1)
const _hoisted_60 = { class: "flex items-start gap-4" }
const _hoisted_61 = { class: "mt-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("dd", null, "No bike lane", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h3", null, "Access", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", null, " Same as above, since the availability of space for a bike facility informs the ease of accessing destinations on a corridor. ", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_67 = { class: "flex items-start gap-4" }
const _hoisted_68 = { class: "mt-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("dd", null, "Seven or more foot wide buffered or protected bike lane", -1)
const _hoisted_70 = { class: "flex items-start gap-4" }
const _hoisted_71 = { class: "mt-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("dd", null, "Less than seven foot wide bike lane", -1)
const _hoisted_73 = { class: "flex items-start gap-4" }
const _hoisted_74 = { class: "mt-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("dd", null, "No bike lane", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Transit", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h3", null, "Mobility", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates ability to provide faster and more reliable transit. ", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", null, " Scoring is a function of the number of lanes (vehicle capacity) and the consistency of a cross section with transit priority treatments including BAT lanes and queue bypasses. ", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h3", null, "Access", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates potential challenges to providing buses access to the curb at bus stops. ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_86 = { class: "flex items-start gap-4" }
const _hoisted_87 = { class: "mt-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Cross section is consistent with transit stopping in lane "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "On-street parking (curb extensions)"),
    /*#__PURE__*/_createElementVNode("li", null, "Parking protected bike lanes (floating bus stops)"),
    /*#__PURE__*/_createElementVNode("li", null, "No parking or bike lanes (bus stops in lane)")
  ])
], -1)
const _hoisted_89 = { class: "flex items-start gap-4" }
const _hoisted_90 = { class: "mt-2" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("dd", null, " Cross section typically requires transit to pull out of lane to access curb ", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Freight", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("h3", null, "Mobility", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", null, "Evaluates potential delay to freight vehicles.", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", null, "Scoring is based on the number of travel lanes.", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h3", null, "Access", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates tradeoffs to curb access for goods loading/unloading and service operations. ", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_102 = { class: "flex items-start gap-4" }
const _hoisted_103 = { class: "mt-2" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("dd", null, "Curbside access on both sides", -1)
const _hoisted_105 = { class: "flex items-start gap-4" }
const _hoisted_106 = { class: "mt-2" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("dd", null, "Curbside access on one side", -1)
const _hoisted_108 = { class: "flex items-start gap-4" }
const _hoisted_109 = { class: "mt-2" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("dd", null, "No curbside access", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "py-2" }, "Traffic", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("h3", null, "Mobility", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates tradeoffs to vehicular capacity to support turning volumes and minimize diversion onto local streets. ", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("p", null, "Scoring is based on the number of travel lanes.", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("h3", null, "Access", -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("h4", null, "Metric", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("p", null, " Evaluates tradeoffs to motorized traffic access to adjacent land uses. ", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("h4", null, "Scoring description", -1)
const _hoisted_121 = { class: "flex items-start gap-4" }
const _hoisted_122 = { class: "mt-2" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("dd", null, "Curbside access on both sides", -1)
const _hoisted_124 = { class: "flex items-start gap-4" }
const _hoisted_125 = { class: "mt-2" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("dd", null, "Curbside access on one side", -1)
const _hoisted_127 = { class: "flex items-start gap-4" }
const _hoisted_128 = { class: "mt-2" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("dd", null, "No curbside access", -1)
const _hoisted_130 = { key: 0 }

import Help from '../street/Help.vue';
import Scorebox from './Scorebox.vue';
import Scorecard from '@/components/cross-section/Scorecard.vue';
import { CrossSection } from '@/composables/cross-section';
import { ref, watch } from 'vue';
import { PrioritySet } from './typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'Scoresheet',
  props: {
  options: { type: Array as () => Array<CrossSection>, required: true },
  mainStreet: {
    type: Boolean,
    default: false,
  },
  priorities: {
    type: Object as () => PrioritySet,
    default: () => ({
      pedestrian: 'higher',
      bicycle: 'higher',
      transit: 'higher',
      freight: 'higher',
      traffic: 'higher',
    }),
  },
  showControls: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

// Get a ref copy of the options to manipulate
const options = ref([...props.options]);

// If we get a new set of options, replace the ref
watch(
  () => props.options,
  (value) => {
    options.value = value;
  }
);

const handleMove = (curr: number, desired: number) => {
  if (desired >= 0 && desired < options.value.length) {
    options.value.splice(desired, 0, ...options.value.splice(curr, 1));
  }
};

const helpClasses = [
  'prose',
  'absolute',
  'w-80',
  'max-h-96',
  'overflow-y-auto',
  'p-4',
  'bg-white',
  'border',
  'border-current',
  'rounded-md',
  'z-50',
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "grid grid-flow-col gap-1 overflow-x-auto",
    style: _normalizeStyle(`
        grid-template-rows: repeat(${__props.showControls ? 9 : 8}, auto);
        grid-template-columns: minmax(min-content, 14rem) repeat(${
          options.value.length
        }, minmax(10rem, 14rem) [col-start]);
      `)
  }, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("dt", _hoisted_7, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("dt", _hoisted_10, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("dt", _hoisted_13, [
                  _createVNode(Scorebox, {
                    score: 1,
                    class: "w-8"
                  })
                ]),
                _hoisted_14
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("dt", _hoisted_21, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("dt", _hoisted_24, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_25
              ])
            ]),
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("dt", _hoisted_31, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_32
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("dt", _hoisted_34, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_35
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("dt", _hoisted_37, [
                  _createVNode(Scorebox, {
                    score: 1,
                    class: "w-8"
                  })
                ]),
                _hoisted_38
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_40,
            _hoisted_41,
            _hoisted_42,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("dt", _hoisted_44, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_45
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("dt", _hoisted_47, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_48
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_39
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_50,
            _hoisted_51,
            _hoisted_52,
            _hoisted_53,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("dt", _hoisted_55, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_56
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("dt", _hoisted_58, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_59
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("dt", _hoisted_61, [
                  _createVNode(Scorebox, {
                    score: 1,
                    class: "w-8"
                  })
                ]),
                _hoisted_62
              ])
            ]),
            _hoisted_63,
            _hoisted_64,
            _hoisted_65,
            _hoisted_66,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("dt", _hoisted_68, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_69
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("dt", _hoisted_71, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_72
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("dt", _hoisted_74, [
                  _createVNode(Scorebox, {
                    score: 1,
                    class: "w-8"
                  })
                ]),
                _hoisted_75
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_49
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_77,
            _hoisted_78,
            _hoisted_79,
            _hoisted_80,
            _hoisted_81,
            _hoisted_82,
            _hoisted_83,
            _hoisted_84,
            _hoisted_85,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("dt", _hoisted_87, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_88
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("dt", _hoisted_90, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_91
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_76
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_93,
            _hoisted_94,
            _hoisted_95,
            _hoisted_96,
            _hoisted_97,
            _hoisted_98,
            _hoisted_99,
            _hoisted_100,
            _hoisted_101,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("dt", _hoisted_103, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_104
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("dt", _hoisted_106, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_107
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("dt", _hoisted_109, [
                  _createVNode(Scorebox, {
                    score: 1,
                    class: "w-8"
                  })
                ]),
                _hoisted_110
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_92
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(Help, null, {
        help: _withCtx(({ show }) => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(helpClasses)
          }, [
            _hoisted_112,
            _hoisted_113,
            _hoisted_114,
            _hoisted_115,
            _hoisted_116,
            _hoisted_117,
            _hoisted_118,
            _hoisted_119,
            _hoisted_120,
            _createElementVNode("dl", null, [
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("dt", _hoisted_122, [
                  _createVNode(Scorebox, {
                    score: 3,
                    class: "w-8"
                  })
                ]),
                _hoisted_123
              ]),
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("dt", _hoisted_125, [
                  _createVNode(Scorebox, {
                    score: 2,
                    class: "w-8"
                  })
                ]),
                _hoisted_126
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("dt", _hoisted_128, [
                  _createVNode(Scorebox, {
                    score: 1,
                    class: "w-8"
                  })
                ]),
                _hoisted_129
              ])
            ])
          ], 512), [
            [_vShow, show]
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_111
        ]),
        _: 1
      })
    ]),
    (__props.showControls)
      ? (_openBlock(), _createElementBlock("span", _hoisted_130))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
      return (_openBlock(), _createBlock(Scorecard, {
        key: `${option.width}:${option.name}`,
        scores: option,
        "main-street": __props.mainStreet,
        priorities: __props.priorities,
        "show-controls": __props.showControls,
        onMoveLeft: ($event: any) => (handleMove(index, index - 1)),
        onMoveRight: ($event: any) => (handleMove(index, index + 1))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", { option: option })
        ]),
        _: 2
      }, 1032, ["scores", "main-street", "priorities", "show-controls", "onMoveLeft", "onMoveRight"]))
    }), 128))
  ], 4))
}
}

})